import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {AsideLeftDisplayDisabledComponent} from './aside-left-display-disabled/aside-left-display-disabled.component';
import {DefaultComponent} from './default/default.component';
import {SharedModule} from '../shared/shared.module';
import {CommonModule} from '@angular/common';
import {CheckPermissionsDirective} from '../directives/permissions/check-permissions.directive';
import { PaginationComponent } from './pagination/pagination.component';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        AsideLeftDisplayDisabledComponent,
        DefaultComponent,
        CheckPermissionsDirective,
        PaginationComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        AsideLeftDisplayDisabledComponent,
        DefaultComponent,
        SharedModule,
        CheckPermissionsDirective,
        PaginationComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ]
})
export class LayoutModule {
}
